import request from './request';

/** 业务类型列表 */
export function detectBusinessTypesApi() {
  return request.get("ent/detection/business-types");
}

/** 保存业务类型 */
export function detectSaveBusinessTypeApi(data) {
  return request.post("ent/detection/business-types", data);
}

/** 模板列表 */
export function detectTemplatesApi(data) {
  return request.get("ent/detection/templates", data);
}

/** 模板详情 */
export function detectTemplateDetailApi(id) {
  return request.get("ent/detection/templates/".concat(id));
}

/** 创建模板 */
export function detectCreateTemplateApi(data) {
  return request.post("ent/detection/templates", data);
}

/** 覆盖 JSON */
export function detectOverwriteConfigApi(id, data) {
  return request.put("ent/detection/templates/".concat(id, "/config"), data);
}

/** 上传 JSON 整包覆盖（FormData，勿手写 Content-Type） */
export function detectImportJsonApi(data) {
  return request.post("ent/detection/templates/import-json", data);
}

/** 克隆 */
export function detectCloneTemplateApi(data) {
  return request.post("ent/detection/templates/clone", data);
}

/** 树预览 */
export function detectTemplateTreeApi(id) {
  return request.get("ent/detection/templates/".concat(id, "/tree"));
}

/** 历史 */
export function detectTemplateHistoryApi(id) {
  return request.get("ent/detection/templates/".concat(id, "/history"));
}

/** 还原 */
export function detectRestoreTemplateApi(id, historyId) {
  return request.post("ent/detection/templates/".concat(id, "/restore/").concat(historyId));
}

/** 启停 */
export function detectTemplateStatusApi(id, data) {
  return request.put("ent/detection/templates/".concat(id, "/status"), data);
}

/** 绑定单位/类别 */
export function detectTemplateBindApi(id, data) {
  return request.put("ent/detection/templates/".concat(id, "/bind"), data);
}

/** 导入 Excel */
export function detectImportExcelApi(data) {
  return request.post("ent/detection/templates/import", data);
}

/** 工单列表 */
export function detectOrdersApi(data) {
  return request.get("ent/detection/orders", data);
}

/** 开单 */
export function detectCreateOrderApi(data) {
  return request.post("ent/detection/orders", data);
}

/** 报告 */
export function detectOrderReportApi(id) {
  return request.get("ent/detection/orders/".concat(id, "/report"));
}

/** 进度 */
export function detectOrderCatalogApi(id) {
  return request.get("ent/detection/orders/".concat(id, "/catalog"));
}

/** 迁移历史 */
export function detectMigrateOrdersApi(data) {
  return request.post("ent/detection/orders/migrate", data);
}

/** 按业务类型拉取本单位可用检测标准 */
export function detectStandardsApi(params) {
  return request.get("ent/detection/standards", params);
}